/**
 * 图片/视频轮播（详情页）
 * 无图时展示品牌默认牛只图（public/images/cattle-default.jpg）
 */
import { useState } from 'react';
import { cosUrl, imgFallback } from '@/utils/constants';

const DEFAULT_CATTLE_IMAGE = cosUrl('/images/cattle-default.jpg');
/** 本地默认图路径（COS 不可达时回退） */
const DEFAULT_CATTLE_IMAGE_LOCAL = '/images/cattle-default.jpg';

interface ImageCarouselProps {
  images?: string[];
  videoUrl?: string;
  alt?: string;
  fallbackText?: string;
}

export default function ImageCarousel({ images = [], videoUrl, alt, fallbackText }: ImageCarouselProps) {
  const [index, setIndex] = useState(0);
  const list = images.length > 0 ? images : [DEFAULT_CATTLE_IMAGE];
  const safeIndex = Math.min(index, list.length - 1);

  if (videoUrl) {
    return (
      <div className="carousel">
        <video className="carousel__media" src={videoUrl} controls poster={images[0] ?? DEFAULT_CATTLE_IMAGE} />
      </div>
    );
  }

  const current = list[safeIndex];

  return (
    <div className="carousel">
      {current ? (
        <img
          className="carousel__media"
          src={current}
          alt={alt ?? '牛只图片'}
          data-local={DEFAULT_CATTLE_IMAGE_LOCAL}
          onError={imgFallback}
        />
      ) : (
        <div className="carousel__placeholder">
          <span className="carousel__emoji">🐂</span>
          <span className="carousel__text">{fallbackText ?? '实拍图待补充'}</span>
        </div>
      )}

      {list.length > 1 ? (
        <>
          <button
            className="carousel__arrow carousel__arrow--left"
            onClick={() => setIndex((safeIndex - 1 + list.length) % list.length)}
            aria-label="上一张"
          >
            ‹
          </button>
          <button
            className="carousel__arrow carousel__arrow--right"
            onClick={() => setIndex((safeIndex + 1) % list.length)}
            aria-label="下一张"
          >
            ›
          </button>
          <div className="carousel__dots">
            {list.map((_, i) => (
              <button
                key={i}
                className={`carousel__dot ${i === safeIndex ? 'active' : ''}`}
                onClick={() => setIndex(i)}
                aria-label={`第 ${i + 1} 张`}
              />
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
